const queryString = require('query-string');

import React from 'react';
import AuthService from '@services/AuthService/AuthService';

class TokenLogin extends React.Component {
    constructor(props) {
        super(props);
        
        const qString = queryString.parse(this.props.location.search);

        if (qString.token && qString.token.length) {
            this.sendTokenRequest(qString.token);
        }
        else this.props.history.push('/login');
    }

    sendTokenRequest(token) {
        AuthService.tokenLogin(token)
            .then(() => this.props.history.push('/latest'))
            .catch(() => this.props.history.push('/login'));
    }    

    render() { return null; }
}

export default TokenLogin;


// WEBPACK FOOTER //
// ./src/views/Pages/TokenLogin/TokenLogin.js